import React from "react";
import axios from "axios";
import { APIURL } from "../../../Global";
import { useAlert } from "react-alert";

function MachineList({ machines, onEdit, onDelete, loading }) {
    const alert = useAlert();

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this machine?")) {
            const tokenString = sessionStorage.getItem("usertoken");
            const token = tokenString ? tokenString.replace(/["]+/g, "") : "";

            try {
                const response = await axios.delete(`${APIURL}/api/v1/staff/machine-view/?machine_id=${id}`, {
                    headers: { Authorization: `Token ${token}` }
                });

                if (response.data.status === "success") {
                    alert.success("Machine deleted successfully");
                    onDelete();
                } else {
                    alert.error(response.data.message || "Failed to delete machine");
                }
            } catch (error) {
                console.error("Error deleting machine:", error);
                alert.error("Error communicating with server");
            }
        }
    };

    if (loading) {
        return <div className="text-center p-5">Loading machines...</div>;
    }

    if (machines.length === 0) {
        return (
            <div className="machine-empty-list p-5 text-center">
                <p>No machines found. Click the button above to add one.</p>
            </div>
        );
    }

    return (
        <div className="machine-list">
            {machines.map((machine) => (
                <div key={machine.id} className="machine-card">
                    <div className="machine-info">
                        <h5>
                            <span className="machine-code">{machine.machine_code}</span>
                            {machine.machine_name}
                        </h5>
                        <p>{machine.description}</p>
                    </div>
                    <div className="machine-actions">
                        <span 
                            className="action-icon edit-icon" 
                            title="Edit"
                            onClick={() => onEdit(machine)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M3 21v-4.25L16.2 3.575q.3-.275.663-.425t.762-.15q.4 0 .775.15t.65.45L20.425 5q.3.275.438.65t.137.775q0 .4-.15.763t-.425.662L7.25 21H3Zm17.025-14.9L17.9 3.975l2.125 2.125ZM16.85 7.125l-12.825 12.85V20H5.05L17.9 7.15l-1.05-1.025Z"/>
                            </svg>
                        </span>
                        <span 
                            className="action-icon delete-icon" 
                            title="Delete"
                            onClick={() => handleDelete(machine.id)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                            </svg>
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default MachineList;
